import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation, faBuilding, faUser } from "@fortawesome/free-solid-svg-icons";
import "@src/components/sosAlert/sosAlertOverlay.css";

const ACK_LOCK_SECONDS = 5;

export const ATTENTION_ASK = "Something is off with this report. Please read it carefully before submission.";

// Full-screen warning shown when a reviewer opens the report of an in-review task that
// wfc-server's AI read flagged as needing attention (mobileservices.reportAssessment).
// Same look as the SOS alert, without the siren; the button unlocks after a few seconds
// so it can't be clicked away unread. Portalled to <body> so the task modal can't clip it.
export const ReportAttentionAlert = ({ reason, sitename, assignee, onAcknowledge }) => {
  const [lockRemaining, setLockRemaining] = useState(ACK_LOCK_SECONDS);

  useEffect(() => {
    const timer = setInterval(() => {
      setLockRemaining((prev) => {
        if (prev <= 1) { clearInterval(timer); return 0; }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const locked = lockRemaining > 0;

  return createPortal(
    <div className="sos-alert-overlay report-attention-overlay" role="alertdialog" aria-live="assertive">
      <div className="sos-alert-card">
        <div className="sos-alert-icon">
          <FontAwesomeIcon icon={faTriangleExclamation} />
        </div>
        <div className="sos-alert-title">REPORT NEEDS ATTENTION</div>
        {sitename && (
          <div className="sos-alert-row">
            <FontAwesomeIcon icon={faBuilding} /> <span>{sitename}</span>
          </div>
        )}
        {assignee && (
          <div className="sos-alert-row">
            <FontAwesomeIcon icon={faUser} /> <span>{assignee}</span>
          </div>
        )}
        {reason && <div className="report-attention-reason">{reason}</div>}
        <div className="report-attention-ask">{ATTENTION_ASK}</div>

        <button className="sos-alert-dismiss" disabled={locked} onClick={onAcknowledge}>
          {locked ? `Open report in ${lockRemaining}s` : "I'll read it carefully"}
        </button>
      </div>
    </div>,
    document.body
  );
};
